/**
@element com-calendar-legend
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-calendar-legend-style.js';
import './style/com-calendar-style.js';

import '@com/icon';
import { COMAdaptiveBehavior } from '@com/adaptive';
import { COMCalendarBehavior, CALENDAR_TYPE } from  './com-calendar-behavior.js';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';

class COMCalendarLegend extends COMCalendarBehavior(GestureEventListeners(COMAdaptiveBehavior(PolymerElement))) {
  static get template() {
    return html`
    <!-- Scoped styles for this element -->

    <style include="com-theme"></style>
    <style include="com-calendar-legend-style"></style>
    <style include="com-calendar-style"></style>

    <div role="region" aria-label\$="[[legendAriaLabel]]" class\$="legends [[_getLegendsClass(isVariableParks)]]">
      <template is="dom-repeat" items="[[_getLegends(dateTypeMap, priceView, isVariableParks, typesWithSlash)]]">
        <template is="dom-if" if="[[!item.hideInLegend]]">
          <template is="dom-if" if="[[item.displayName]]">
            <div class$="legendItem [[item.class]]">
              <template is="dom-if" if="[[item.isIcon]]">
                <template is="dom-if" if="[[item.isOverlappingIcon]]">
                  <div class="overlapping" aria-hidden="true">
                    <com-icon class\$="dateTypeIndicatorIcon [[item.firstClass]] firstIcon" value="[[item.firstIcon]]"></com-icon>
                    <com-icon class\$="dateTypeIndicatorIcon [[item.secondClass]] secondIcon" value="[[item.secondIcon]]"></com-icon>
                  </div>
                </template>
                <template is="dom-if" if="[[!item.isOverlappingIcon]]">
                  <com-icon class\$="dateTypeIndicatorIcon [[item.class]]" value="[[item.content]]"  aria-hidden="true"></com-icon>
                </template>
              </template>
              <template is="dom-if" if="[[!item.isIcon]]">
                <div class\$="dateTypeIndicator [[item.class]]" inner-h-t-m-l="[[item.content]]"></div>
              </template>
              <div class\$="legendDisplayName [[item.class]]">
                <com-html value="[[item.displayName]]"><com-html>
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
`;
  }

  static get is() { return 'com-calendar-legend'; }

  static get properties() {
    return {
      /**
       * @desc Determine if we have a variable quantity of parks.
       * @type {Boolean}
       */
      isVariableParks: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Object with date type information
       * @type {Object}
       */
      dateTypeMap: {
        type: Object,
        value: {
          all: {
            class: 'all',
            content: '',
          },
          none: {
            class: 'none',
            content: '',
          }
        }
      },
      /**
       * @desc Determine if price view should be displayed
       * @type {Boolean}
       */
      priceView: {
        type: Boolean,
        value: false
      },
      typesWithSlash: {
        type: Array,
        value: ['unavailable']
      },
      /**
       * @desc aria-label attribute to set on legend container
       * @type {String}
       */
      legendAriaLabel: {
        type: String,
        value: 'Legend'
      }
    }
  }

    /**
   * @desc Get the style for the legends.
   * @param {Boolean} isVariableParks
   */
     _getLegendsClass(isVariableParks) {
      return isVariableParks ? 'sameLine' : '';
    }

  /**
   * @desc Builds the legends array for the calendar
   * @param {Object} dateTypeMap containing the configuration map
   * @param {Boolean} priceView indicates if the calendar is presenting in Prices mode
   * @param {Boolean} isVariableParks indicates if we have a variable quantity of parks.
   * @return {Array} an array of legend items to be displayed
   */
  _getLegends(dateTypeMap, priceView, isVariableParks, typesWithSlash) {
    let legends = [];
    for (let dateTypeKey in dateTypeMap) {
      let currentItem = JSON.parse(JSON.stringify(dateTypeMap[dateTypeKey]));
      // If currentItem.visibility is undefined, we assume it's 'none'
      if (currentItem.displayName && currentItem.visibility === this._getCalendarType(priceView)) {
        if ((isVariableParks && currentItem.class === 'blocked') || (typesWithSlash.includes(currentItem.class))) {
          currentItem.content = '<svg aria-hidden="true" class="slash" disabled><line x1="20%" y1="20%" x2="80%" y2="80%"/></svg>';
        }
        legends.push(currentItem);
      }
    }
    legends.sort((a, b) => { return a.displayOrder && b.displayOrder && a.displayOrder > b.displayOrder ? 1 : -1 })
    return legends;
  }

    /**
   * @desc Evaluates the isPriceView param to identify the type of calendar we're presenting
   * @param {Boolean} priceView indicates if the calendar is presenting in Prices mode
   * @return {String} `price-view` if `isPriceView` is true, `generic-view` otherwise.
   */
     _getCalendarType(isPriceView) {
      return isPriceView === true ? CALENDAR_TYPE.priceView : CALENDAR_TYPE.genericView;
    }

}
customElements.define(COMCalendarLegend.is, COMCalendarLegend);
